import { IconFile, IconFileMusic, IconFileSpreadsheet, IconFileText, IconFileTypePdf, IconFileWord, IconFileZip, IconPaperclip, IconVideo, IconX } from '@tabler/icons-react';
import mime from 'mime';
import React, { useCallback, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { uploadFile } from '../../../../api/api.global';
import { socketKeys } from '../../../../statics/socketKeys';

const FileSendInChat = ({ socket, visitorData }) => {
    const [show, setShow] = useState(false);
    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null)

    const handleClose = () => { setFile(null); setShow(false) };
    const handleShow = () => setShow(true);

    const sendFileMessage = useCallback(async () => {
        if (socket) {
            let msg = document.getElementById("message")?.value?.trim();
            let postData = {
                file: await uploadFile(file, "chat"),
                chatSessionId: visitorData?._id,
                messageType: 2,
            }
            if (msg) {
                postData.message = msg;
            }
            socket.emit(socketKeys.SEND_MESSAGE, postData);
            setFile(null);
            handleClose();
        }
    }, [socket, file, visitorData]);

    const onFileChange = (e) => {
        const localFile = e.target.files[0];
        setFile(localFile);
        if (localFile) {
            handleShow();
        }
    }

    return (
        <>
            <input type="file" ref={fileInputRef} onChange={onFileChange} className="hidden" accept='image/*' />
            <button
                className='p-2 hover:bg-gray-100 rounded-full hover:text-gray-500 hover:cursor-pointer text-white transition'
                onClick={() => fileInputRef.current.click()}
            >
                <IconPaperclip size={20} className='text-gray-800' />
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Send File</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='mb-4'>
                        <GetFileType file={file} />
                    </div>

                    <div className='mb-3'>
                        <label htmlFor="name" className='text-sm font-semibold mb-1'>Message</label>
                        <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='message' rows={5} ></textarea>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => sendFileMessage()}>Send</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FileSendInChat;

const GetFileType = ({ file }) => {

    const mimeType = mime.getType(file?.name) || '';

    const renderIcon = () => {

        if (['image/jpeg', 'image/png', 'image/webp'].includes(mimeType)) {
            return file && <img src={URL.createObjectURL(file)} alt="" className='max-h-96 mx-auto rounded-md max-w-full' />;
        }

        if (['application/pdf'].includes(mimeType)) return <IconFileTypePdf size={50} />;
        if (['application/vnd.ms-excel', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(mimeType)) return <IconFileSpreadsheet size={50} />;
        if (['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(mimeType)) return <IconFileWord size={50} />;
        if (['text/plain'].includes(mimeType)) return <IconFileText size={50} />;
        if (['application/zip', 'application/x-7z-compressed', 'application/x-bzip', 'application/x-bzip2', 'application/gzip', 'application/vnd.android.package-archive'].includes(mimeType)) {
            return <IconFileZip size={50} />;
        }
        if (mimeType.startsWith('video/')) return <IconVideo size={50} />;
        if (mimeType.startsWith('audio/')) return <IconFileMusic size={50} />;

        return <IconFile size={50} />;
    };

    return (
        <div>
            <div className='flex items-center justify-center text-6xl p-2'> {renderIcon()}</div>
            <div className='flex items-center justify-center text-lg p-2'> {file?.name} - {((file?.size / 1024) / 1024).toFixed(2)}Mb</div>
        </div>

    )
}